import React, { FC, useMemo } from 'react';

import { ProductData, StoreRefreshPopup } from '@appcharge/shared-ui';

import useOffersUI from 'api/useOffersUI';
import { OfferPreviewShell } from 'views/Offers/components/OfferPreviewShell';
import { IResolvedProgressBarMission } from 'views/Offers/utils/resolveProgressBarPoints';
import { POPUP_CONTAINER_STYLE } from 'views/OfferDesign/pages/OfferDesignForm/components/OfferDesignPreview/OfferDesignPreview.consts';

const PREVIEW_CONTAINER_ID = 'popup-preview';
const MAX_PREVIEW_PRODUCTS = 4;

interface ITriggeredPopupPreviewProps {
  publisherId?: string;
  currentOfferUI: string;
  currentPrice: number;
  previewProducts: ProductData[];
  progressBarPoints?: IResolvedProgressBarMission[];
}

export const TriggeredPopupPreview: FC<ITriggeredPopupPreviewProps> = ({
  publisherId,
  currentOfferUI,
  currentPrice,
  previewProducts,
  progressBarPoints
}): React.ReactElement => {
  const { getOfferUI } = useOffersUI(publisherId, currentOfferUI);
  const offerData = getOfferUI?.data;

  const cappedPreviewProducts = useMemo<ProductData[]>(
    () => previewProducts.slice(0, MAX_PREVIEW_PRODUCTS),
    [previewProducts]
  );

  let buttonText = `$${currentPrice}`;
  if (currentPrice.toString() === '0') {
    buttonText = 'Collect';
  }

  return (
    <OfferPreviewShell
      containerId={PREVIEW_CONTAINER_ID}
      containerStyle={POPUP_CONTAINER_STYLE}
    >
      {() => (
        <StoreRefreshPopup
          open
          disableBodyLock
          onClose={() => {}}
          onCollect={() => {}}
          title={offerData?.specialOffer?.title || ''}
          titleColor={offerData?.specialOffer?.fontColor?.colorOne}
          titleWeight={offerData?.specialOffer?.fontWeight}
          backgroundColor={offerData?.specialOffer?.backgroundColor?.colorOne}
          backgroundImage={offerData?.backgroundImage}
          borderColor={offerData?.borderColor}
          borderWidth={offerData?.borderWidth}
          buttonText={buttonText}
          products={cappedPreviewProducts}
          container={document.getElementById(PREVIEW_CONTAINER_ID)}
          progressBarPoints={progressBarPoints}
        />
      )}
    </OfferPreviewShell>
  );
};
